module.exports = __webpack_public_path__ + "static/media/IMG_20190826_165739.image.1dd63720.png";